var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"tm-ticks"},_vm._l((_vm.ticks),function(tick,i){return _c('i',{key:i,attrs:{"data-time":tick.time}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }